import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: .2rem;
  border-radius: 0.2rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
`

export const Row = styled.div`
  display: flex;
`

export const Column = styled.div<{ minWidth?: string; backgroundColor?: string, pl?: string}>`
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: .2rem;
  min-width: ${(props) => (props.minWidth ? props.minWidth : '50%')};
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'transparent')};
  padding-left: ${(props) => (props.pl ? props.pl : '.2rem')};
`

export const CustomButton = styled(ButtonMui)`
  width: 100%;   
  height: 1.8rem !important;
  margin-top: .5rem !important;
`
export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;

  p {
    font-size: 16px;
  }
`
